<div class="category-home-description">
    <h1>Contact Us!</h1>
    <div style="display: flex; justify-content: space-between; flex-wrap: wrap; width: 100%;">
        <div id="contact-us-form">
            <!-- Start Form -->
            <form [formGroup]="angForm" (ngSubmit)="submitForm()" novalidate>
                <!-- Name Validator -->
                <div class="form-group">
                    <label>Name:</label>
                    <input class="form-control" formControlName="name" type="text">
                </div>
                <div *ngIf="angForm.controls['name'].invalid && (angForm.controls['name'].dirty || angForm.controls['name'].touched)"
                    class="alert alert-danger">
                    <div *ngIf="angForm.controls['name'].errors.required">
                        Name is required.
                    </div>
                </div>

                <!-- Email Validator -->
                <div class="form-group">
                    <label>Email:</label>
                    <input class="form-control" formControlName="address" type="email">
                </div>
                <div *ngIf="angForm.controls['address'].invalid && (angForm.controls['address'].dirty || angForm.controls['address'].touched)"
                    class="alert alert-danger">
                    <div *ngIf="angForm.controls['address'].errors.required">
                        Email is required.
                    </div>
                </div>

                <!-- Telephone - optional -->
                <div class="form-group">
                    <label>Telephone (optional):</label>
                    <input class="form-control" formControlName="telephone" type="text"
                        placeholder="(###) ###-#### (optional)">
                </div>

                <!-- Message Validator -->
                <div class="form-group">
                    <label>Message:</label>
                    <textarea class="form-control" formControlName="message" type="text"
                        placeholder="Type your message..."></textarea>
                </div>
                <div *ngIf="angForm.controls['message'].invalid && (angForm.controls['message'].dirty || angForm.controls['message'].touched)"
                    class="alert alert-danger">
                    <div *ngIf="angForm.controls['message'].errors.required">
                        Please let us know what you're interested in.
                    </div>
                </div>

                <!-- Submit -->
                <button type="submit" [disabled]="angForm.invalid" class="btn btn-primary" style="margin-top: 1em;">
                    Submit</button>

                <!-- End Form -->
            </form>
            <div class="break"></div>
            <div style="padding-top: 2%;">
                <i class="fa fa-phone" style="font-size:24px">&nbsp; Phone: (916) 920-4110</i><br>
                <!-- <i class="fa fa-fax" style="font-size:24px">&nbsp;Fax: (916) 920-4390</i><br> -->
                <i class="fa fa-envelope" style="font-size:24px">&nbsp;Email: info@pfcvalves.com</i><br>
            </div>
        </div>
        <div id="contact-us-break"></div>
        <div id="contact-us-map">
            <div class="gmap_canvas h-100 w-100">
                <iframe width="100%" height="100%" id="gmap_canvas "
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d6209.426828427402!2d-121.34194842365449!3d38.90766844609744!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x809b3c6f1c73d44d%3A0x17876517b3de8dbc!2s1751%20Aviation%20Blvd%2C%20Lincoln%2C%20CA%2095648!5e0!3m2!1sen!2sus!4v1765398919742!5m2!1sen!2sus" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"
                    frameborder="0 " scrolling="no" marginheight="0" marginwidth="0 "></iframe>
            </div>
        </div>
    </div>
</div>
